import { ErrorHandler, Injectable } from '@angular/core';

// Thin guard around the global Sentry browser SDK, which is loaded app-wide in
// the layout <head> (shared/_sentry). It is absent in dev and whenever no DSN is
// configured, so every call is guarded - the planner never crashes if Sentry
// isn't there. The `area: planner` tag separates island errors in Sentry.
type SentryGlobal = {
  captureException?: (err: unknown, context?: { tags?: Record<string, string> }) => void;
};

export function captureException(err: unknown): void {
  (window as unknown as { Sentry?: SentryGlobal }).Sentry?.captureException?.(err, {
    tags: { area: 'planner' },
  });
}

// Bridges Angular's caught errors to Sentry. Angular's default ErrorHandler only
// console.errors, so those errors never bubble to the global window.onerror
// handler the browser SDK relies on - this forwards them while keeping the log.
@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(err: unknown): void {
    console.error(err);
    captureException(err);
  }
}
